import {Routes, Route} from "react-router-dom";
import Navbar from "./components/Navbar";
import Shop from "./components/Shop.js";

import Products from "./components/Products.js";
import Cart from "./components/Cart.js";
import Login from "./components/Login.js";
import Footer from "./components/Footer";
import ShopCategory from "./components/ShopCategory";
import men_banner from "./components/Assets/banner_mens.png";
import women_banner from "./components/Assets/banner_women.png";
import kid_banner from "./components/Assets/banner_kids.png";

function App() {
  return (
    <div className="App">
      <Navbar />

      <Routes>
        <Route path="/" element={<Shop />} />
        <Route
          path="/men"
          element={<ShopCategory banner={men_banner} category="men" />}
        />
        <Route
          path="/women"
          element={<ShopCategory banner={women_banner} category="women" />}
        />
        <Route
          path="/kids"
          element={<ShopCategory banner={kid_banner} category="kid" />}
        />
        <Route path="/product" element={<Products />}>
          <Route path=":productId" element={<Products />} />
        </Route>
        <Route path="/cart" element={<Cart />} />
        <Route path="/login" element={<Login />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
